<template>
    <div style="background-color: white; margin: 10px 20px">
      <el-row>
        <el-col :span="24">
          <div class="harpIDbtmline">付迅酒店和Harp系统匹配</div>
        </el-col>
      </el-row>
      <div class="hotel_container_panel">
        <div class="harpIDtopHeight">
          <div class="harpIDtopHeight">
            <el-button type="warning" class="harpIDbtn" @click="uploadFile2">上传文件</el-button>
            <input type="file" @change="fileValueChange2()" ref="uploadFile2" enctype="multipart/form-data" id="import_btn" style="display: none"/>
          </div>
        </div>
        <div>
          <el-main style="padding-top: 0; padding-bottom: 0">
            <el-table :data="harpIDData">
              <el-table-column prop="uploadName" label="上传文件名称" align="center"></el-table-column>
              <el-table-column prop="createDate" label="上传时间" align="center"></el-table-column>
              <el-table-column prop="createBy" label="创建者" align="center"></el-table-column>
              <el-table-column :label="$t('USERDIALOG.OPERATION')">
                <template #default="scope">
                  <el-button v-if="scope.row.statusing" @click="downloadHarpIdMapping(scope.row)" type="text" size="small">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer style="margin: 1rem 2rem; background-color: #ffffff">
            <el-pagination 
              style="float: right; margin: 1rem 0" 
              background 
              layout="total,sizes,prev, pager, next" 
              :page-sizes="[5, 10, 15, 20]" 
              :page-size="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange" 
              :total="totalCount" 
              v-model:current-page="Pageone"
            >
            </el-pagination>
          </el-footer>
        </div>
      </div>
      <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
    </div>
</template>
<script>
import {
  importHarpID,getHarpIDMapping,downloadHrapIdMapping,
} from "@/api/platformData";
import { getFileName } from "@/utils/utils.js";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
export default {
  name: "HBEMatchHarpId",
  components: {
      ConfirmBoxs,
  },
  data() {
    return {
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      harpIDData: [],
      Pageone: 1,
      pageSize: 5,
      totalCount: 0,
    };
  },
  mounted() {
    this.getHarpIDMapRecord();
  },
  methods: {
    uploadFile2() {
      this.$refs.uploadFile2.click();
    //   this.$confirm("本次上传会覆盖历史记录, 请确保上传数据为全量数据", {
    //   confirmButtonText: "确定",
    //   cancelButtonText: "关闭",
    //   cancelButtonClass: "btn-custom-cancel",
    //   center: true,
    //   })
    //   .then(() => {
    //     this.$refs.uploadFile2.click();
    //  })
    //   .catch(() => {
    //     // this.$message.error("已取消上传");
    //   });
    },
    fileValueChange2() {
      // 选中文件后，会触发input的change事件，即会进入此函数
      var formData = new FormData();
      formData.append(
      "file",
      this.$refs.uploadFile2.files[0],
      this.$refs.uploadFile2.files[0].name,
      );
      importHarpID(formData)
      .then((res) => {
        if (res.code == 200) {
          this.confirmFlag = true;
          this.confirmMsg = this.$t("MESSAGE.HARPID");
          document.getElementById("import_btn").value = "";
          this.getHarpIDMapRecord();
        }else if (res.code == 500) { //temp
        this.confirmFlag = true;
        this.confirmMsg = "上传失败，请检查文件并重新上传";
        //清空value值  解决无法上传相同名字文件的问题
        document.getElementById("import_btn").value = "";
        }
      })
      .catch((e) => {
        this.confirmFlag = true;
        this.confirmMsg = "上传失败，请检查文件并重新上传";
        document.getElementById("import_btn").value = "";
     });
    },
    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    //分页
    handleCurrentChange(pageNum) {
      this.Pageone = pageNum;
      this.getHarpIDMapRecord();
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getHarpIDMapRecord();
    },
    getHarpIDMapRecord() {
      let Params = {
        params: {
          page: this.Pageone,
          per_page: this.pageSize,
        },
      };
      getHarpIDMapping(Params).then((res) => {
        if (res.code == 200) {
          this.harpIDData = res.data.data;
          this.totalCount = res.data.total;
        }
      });
    },
    downloadHarpIdMapping(row){
      let downParam = {
        pkid:row.pkid,
      };
      //开始下载
      this.$message(this.$t("MESSAGE.DOWNLOADSTART"));
      downloadHrapIdMapping(downParam)
      .then((res) => {
        // 执行下载
        const downloadLink = document.createElement("a");
        // 设置下载文件名
        const fileName = getFileName();
        // .csv 文件后缀
        downloadLink.download = fileName + ".txt"; // 文件名称
        downloadLink.style.display = "none";
        //csv文件的type  text/csv    xls:application/vnd.ms-excel
        const blob = new Blob([res], { type: "text/plain" }); //字节转成 Blob
        downloadLink.href = URL.createObjectURL(blob);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch((error) => {
        console.log("导出Excel", error);
      });
    },
  }
};
</script>
<style scoped>
.harpIDbtmline {
  border-bottom-color: #e6a23c;
  border-bottom-style: solid;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1rem;
  margin-top: 1rem;
  font-size: 1.5rem;
}
.harpIDtopHeight {
  margin-top: 2rem;
  font-size: 1.5rem;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
